import * as Sentry from '@sentry/nextjs'

import { ServerError } from '@apollo/client'
import { ErrorHandler, ErrorResponse } from '@apollo/link-error'

const errorLogger: ErrorHandler = ({
  graphQLErrors,
  networkError,
  operation,
}: ErrorResponse) => {
  if (graphQLErrors) {
    graphQLErrors.forEach(({ message, path, extensions }) => {
      Sentry.withScope((scope) => {
        scope.setTag('gql.operation', operation.operationName)
        scope.setTag('gql.error_code', String(extensions?.code ?? 'UNKNOWN'))
        scope.setExtra('gql.path', path)
        scope.setFingerprint(['gql-error', operation.operationName, message])
        Sentry.captureException(
          new Error(`[GraphQL] ${operation.operationName}: ${message}`)
        )
      })
    })
  }

  if (networkError) {
    Sentry.withScope((scope) => {
      scope.setTag('gql.operation', operation.operationName)
      scope.setTag('network.error_name', networkError.name)

      const statusCode = (networkError as ServerError)?.statusCode
      if (statusCode) {
        scope.setTag('gql.status_code', statusCode)
      }

      scope.setFingerprint([
        'network-error',
        operation.operationName,
        networkError.name,
      ])

      Sentry.captureException(
        new Error(
          `[Network] ${operation.operationName}: ${networkError.message}`
        )
      )
    })
  }
}

export { errorLogger }
